import { type QConfigTableData } from '@exam-management/common/types';
import { Dialog, Form, type DialogProps } from '@shared/components';
import { useState } from 'react';

import {
  UpdateItemSetQuestionConditionsFormProvider,
  UpdateItemSetQuestionConditionsProvider,
  useUpdateItemSetQuestionConditions,
} from '../../providers';
import { type ModalContentMapType } from '../../types';
import { SelectTopicContent, type SelectTopicContentProps } from '../select-topic-content';
import { UpdateItemSetQuestionsConditionsFormLogic } from '../update-item-set-questions-conditions-form-logic';

export interface UpdateItemSetQuestionConditionsModalProps extends DialogProps {
  data: QConfigTableData;
  onClose: () => void;
}

export default function UpdateItemSetQuestionConditionsModal(
  props: Readonly<UpdateItemSetQuestionConditionsModalProps>,
) {
  const { open: isModalOpen, data, onClose } = props;
  const [modalContent, setModalContent] = useState<keyof ModalContentMapType>(
    'ADD_ITEM_SET_QUESTION_CONTENT',
  );

  const changeToSelectTopicContent = () => {
    setModalContent('SELECT_TOPIC_CONTENT');
  };

  const changeToEditQuestionContent = () => {
    setModalContent('ADD_ITEM_SET_QUESTION_CONTENT');
  };

  return (
    <Dialog
      open={isModalOpen}
      onClose={onClose}
      slotProps={{
        paper: {
          component: Form,
        },
      }}
    >
      <UpdateItemSetQuestionConditionsProvider rowData={data}>
        <UpdateItemSetQuestionConditionsFormProvider>
          {modalContent === 'ADD_ITEM_SET_QUESTION_CONTENT' ? (
            <UpdateItemSetQuestionsConditionsFormLogic
              onClose={onClose}
              onCancel={onClose}
              onClickSelectTopic={changeToSelectTopicContent}
            />
          ) : null}
          {modalContent === 'SELECT_TOPIC_CONTENT' ? (
            <SelectTopicContentWithContext onClose={onClose} onBack={changeToEditQuestionContent} />
          ) : null}
        </UpdateItemSetQuestionConditionsFormProvider>
      </UpdateItemSetQuestionConditionsProvider>
    </Dialog>
  );
}

function SelectTopicContentWithContext(
  props: Readonly<Pick<SelectTopicContentProps, 'onClose' | 'onBack'>>,
) {
  const { onClose, onBack } = props;
  const { chapterData, levelItemsWithLevel, checkExistOnStructures } =
    useUpdateItemSetQuestionConditions();

  return (
    <SelectTopicContent
      mode='edit'
      chapterData={chapterData}
      levelItemsWithLevel={levelItemsWithLevel}
      checkExistOnStructures={checkExistOnStructures}
      onClose={onClose}
      onBack={onBack}
    />
  );
}
